import './App.css'
import { StrictMode } from 'react';
import { AppRoutes } from './routes';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { Error404 } from './components/page-errors/Error404'
//import { Provider } from 'react-redux';
//import { store } from './redux/store';

function App() {

    const queryClient = new QueryClient();

  return (
      <StrictMode>
          <ErrorBoundary fallback={<Error404 />}>
              
                  <QueryClientProvider client={queryClient}>
                      <BrowserRouter>
                          <AppRoutes />
                      </BrowserRouter>
                  </QueryClientProvider>
         
          </ErrorBoundary>
      </StrictMode>
  )
}

export default App
